<div fxLayout="row" class="cl-device-input cl-dynamic-element-input" *ngIf="deviceInput.isVisible">

    <!--Invoke the recursive directive for each input associated with the static input list.-->
    <dl-device-input [deviceInfo]="deviceInfo"
         [deviceInput]="deviceInput.$sections"
         [deviceInputTemplate]="'inputSection'"
         [displayCount]="deviceInput.value"
         [deviceInputForm]="deviceInputForm"
         [setDeviceInfo]="setDeviceInfo"
    >
    </dl-device-input>
</div>
